type ShortcutsType = {
    [key: string]: {
        [key: string]: {
            keys: Readonly<string | string[]>
            description: string
        }
    }
}

export const Shortcuts = {
    General: {
        DisplayShortcutModal: {
            keys: 'Mod+/',
            description: 'Show all shortcuts',
        },
        DisplaySearchModal: {
            keys: ['Mod+K'],
            description: 'Search for Towns, channels, or DMs',
        },
        CreateNewTown: {
            keys: 'Mod+Alt+N',
            description: 'Create a new town',
        },
        DismissDialog: {
            keys: 'Escape',
            description: 'Dismiss dialogs',
        },
        ClearAllUnreads: {
            keys: 'Shift+Escape',
            description: 'Mark all towns as read',
        },
    },
    Navigation: {
        DisplayTownInfo: {
            keys: 'Mod+Shift+I',
            description: 'Display town info',
        },
        NavigateToPreviousTown: {
            keys: 'Mod+Alt+ArrowUp',
            description: 'Navigate to previous town',
        },
        NavigateToNextTown: {
            keys: 'Mod+Alt+ArrowDown',
            description: 'Navigate to next town',
        },
        NavigateToPreviousChannel: {
            keys: 'Alt+ArrowUp',
            description: 'Navigate to previous channel',
        },
        NavigateToNextChannel: {
            keys: 'Alt+ArrowDown',
            description: 'Navigate to next channel',
        },
        NavigateUp: {
            keys: 'ArrowUp',
            description: 'Navigate up in lists',
        },
        NavigateDown: {
            keys: 'ArrowDown',
            description: 'Navigate down in lists',
        },
        SelectItem: {
            keys: 'Enter',
            description: 'Select current item',
        },
        DisplayChannelInfo: {
            keys: 'Alt+I',
            description: 'Display channel info',
        },
        DisplayChannelDirectory: {
            keys: 'Shift+Mod+E',
            description: 'Display channel directory',
        },
    },
    ['Direct Messages']: {
        CreateMessage: {
            keys: 'Mod+Shift+K',
            description: 'Create new message',
        },
        DirectReply: {
            keys: 'R',
            description: 'Direct Reply',
        },
    },
    Messages: {
        EditMessage: {
            keys: 'E',
            description: 'Edit message',
        },
        DeleteMessage: {
            keys: 'Backspace',
            description: 'Delete message',
        },
        ReplyInThread: {
            keys: 'R',
            description: 'Reply in Thread',
        },
        ReactToMessage: {
            keys: 'Mod+E',
            description: 'React to message',
        },
        MarkAsUnread: {
            keys: 'U',
            description: 'Mark as Unread',
        },
        CopyLinkToMessage: {
            keys: 'L',
            description: 'Copy link to message',
        },
        TipMessage: {
            keys: 'T',
            description: 'Tip message',
        },
    },
    Editor: {
        BoldText: {
            keys: 'Mod+B',
            description: 'Bold',
        },
        ItalicText: {
            keys: 'Mod+I',
            description: 'Italic',
        },
        UnderlineText: {
            keys: 'Mod+U',
            description: 'Underline',
        },
        OpenGifPicker: {
            keys: 'Mod+G',
            description: 'Open GIF picker',
        },
        OpenEmojiPicker: {
            keys: 'Mod+E',
            description: 'Open emoji picker',
        },
        SubmitForm: {
            keys: 'Mod+Enter',
            description: 'Submit form',
        },
    },
    Debug: {
        ToggleTimelineMode: {
            keys: 'Mod+Shift+O',
            description: 'Toggle timeline recorder mode',
        },
        TimelinePreviousFrame: {
            keys: 'ArrowLeft',
            description: 'Previous timeline frame',
        },
        TimelineNextFrame: {
            keys: 'ArrowRight',
            description: 'Next timeline frame',
        },
        TimelineJumpToStart: {
            keys: 'Mod+Shift+ArrowLeft',
            description: 'Jump to timeline start',
        },
        TimelineJumpToEnd: {
            keys: 'Mod+Shift+ArrowRight',
            description: 'Jump to timeline end',
        },
        TimelineStopInteractive: {
            keys: 'Enter',
            description: 'Stop timeline interactive mode',
        },
        ClearConsole: {
            keys: 'q',
            description: 'Clear console',
        },
        ToggleDebugger: {
            keys: 'b',
            description: 'Toggle debug visualizer',
        },
    },
} as const satisfies ShortcutsType

export const ShortcutActions = {
    ...Shortcuts.General,
    ...Shortcuts.Navigation,
    ...Shortcuts['Direct Messages'],
    ...Shortcuts.Messages,
    ...Shortcuts.Editor,
    ...Shortcuts.Debug,
}

export type ShortcutAction = keyof typeof ShortcutActions
